function GestionProgramacionesGPS() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Gestión Programaciones GPS</h1>
      <div className="bg-white rounded shadow p-6">
        <p className="text-gray-700">Aquí irá el módulo de gestión de programaciones GPS. Puedes migrar aquí la funcionalidad desde tu sistema PHP.</p>
      </div>
    </div>
  )
}

export default GestionProgramacionesGPS 